<template>
  <div>
    <div class="ware-house process">
      <div>
        <em class="iconfont icon-close" @click="closeList"></em>
      </div>
      <div class="new-invisit-content">
        <div class="ware-view">
          <h2 v-if="!isWarehouseManager || isOwner">{{$t('DealGoOut')}}</h2>
          <div class="door-con item-list" v-if="doorList.length && !isWarehouseManager || isOwner">
            <h3>{{$t('VisitorConfirmation')}}：</h3>
            <div class="item" v-for="item in doorList" :key="'door'+item.id">
              <label>{{item.postName}}</label>
              <button @click="NotesDoor(item.id)">{{$t('ConfirmGoingOut')}}</button>
            </div>
          </div>
           <h2 v-if="isWarehouseManager && !isOwner" style="margin-bottom:0;">{{$t('AddNotes')}}</h2>
          <div class="notes-con item-list" v-if="notesList.length">
            <h3>{{$t('RemarksForVisitors')}}：</h3>
            <div class="item" v-for="(item, preindex) in notesList" :key="'notes'+item.postName">
              <label>{{item.postName}}</label>
              <div class="select-time-con">
                <div class="select-time" @click="getDateinfo(item.id, preindex)">
                  <input v-model="item.value" :placeholder="$t('PleaseSelectTime')" readonly="readonly">
                  <i class="iconfont icon-down"></i>
                </div>
                <div class="ul-con" v-show="item.show">
                  <ul>
                    <li
                      v-for="(list, index) in item.dateList"
                      :key="list.targetDate"
                      @click="handleTimeChange(preindex, index, list.targetDate)"
                      :class="{'grey':list.isAllAddRemark == true }"
                    >{{ list.targetDate }}</li>
                  </ul>
                </div>
              </div>
              <button @click="confirmNotes(preindex)">{{$t('GoAdd')}}</button>
            </div>
          </div>
        </div>
      </div>
      <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    </div>
    <alertModal
      :modalType="'simple'"
      :isModalShown="isShowMessage"
      :modalTitle="modalMessage"
      @cancel="isShowMessage = !isShowMessage"
    ></alertModal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import alertModal from "@/components/alertModal.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import dateTimePicker from "@/components/dateTimePicker.vue";
import {
  getGuardPostList,
  getInvitationInfoForAgreeToLeave,
  getCheckInSecurityGuardPostList,
  getChectoutRemarkByDate,
  getChectoutRemarkTargetDate
} from "@/utils/api";
import { checkNested } from "@/utils/utils";
import Moment from "moment";

export default {
  name: "proceseegoout",
  props: {
    invitationId: String,
    isWarehouseManager: Boolean,
    isOwner: Boolean
  },
  components: {
    dateTimePicker,
    Loading,
    alertModal
  },
  data() {
    return {
      isWareHouseShow: true,
      isLoading: false,
      doorList: [],
      isShowError: false,
      errorMessage: "",
      isShowMessage: false,
      modalMessage: "",
      notesList: []
    };
  },

  mounted() {
    const invitationId = this.invitationId;
    getGuardPostList(invitationId).then(res => {
      if (checkNested(res, "data", "content", "model")) {
        if (res.data.content.status === 1) {
          this.doorList = res.data.content.model;
          console.log("出门确认列表");
          console.log(this.doorList);
        }
      }
    });

    getCheckInSecurityGuardPostList(invitationId).then(res => {
      console.log(res);
      if (checkNested(res, "data", "content", "model")) {
        if (res.data.content.status === 1) {
          console.log("日期门列表");
          console.log(res.data.content.model);
          this.notesList = res.data.content.model;
          this.notesList.forEach(item => {
            item.value = "";
            item.show = false;
            item.showItem = "";
            item.dateList = [];
          });
        }
      }
    });
  },
  methods: {
    closeList() {
      this.$emit("closeProcessGoOut", false);
    },
    NotesDoor(gateId) {
      const invitationId = this.invitationId;
      getInvitationInfoForAgreeToLeave(invitationId, gateId).then(res => {
        if (checkNested(res, "data", "content", "model")) {
          console.log("enter");
          if (res.data.content.status === 1) {
            console.log(this.$router.push);
            this.isLoading = true;
            let _this = this;
            setTimeout(() => {
              this.closeList();
              this.$router.push({
                path: `/inviteAgreeToLeaveDetail/${invitationId}/${gateId}`
              });
              _this.isLoading = false;
            }, 1000);
          } else {
            this.modalMessage = res.data.content.message;
            this.isShowMessage = true;
          }
        }
      });
    },
    getDateinfo(doorId, preindex) {
      if (this.notesList[preindex].dateList.length == 0) {
        // 该门岗没有需要添加备注的访客
        const invitationId = this.invitationId;
        getChectoutRemarkTargetDate(invitationId, doorId).then(res => {
          if (res.data.status == "001") {
            console.log("获取门岗对应的日期");
            console.log(res);
            if (res.data.content.length) {
              this.notesList[preindex].dateList = res.data.content;
              this.showItem(preindex);
            } else {
              this.modalMessage = this.$t("GateHasNoVisitors");
              this.isShowMessage = true;
            }
          }
        });
      } else {
        this.showItem(preindex);
      }
    },
    showItem(index) {
      let showItem = this.notesList[index];
      showItem.show = !this.notesList[index].show;
      this.$set(this.notesList, index, showItem);
    },
    handleTimeChange(preindex, index, timeValue) {
      let timeItem = this.notesList[preindex];
      timeItem.value = timeValue;
      timeItem.showItem = index;
      timeItem.show = false;
      this.$set(this.notesList, preindex, timeItem);
    },
    confirmNotes(item) {
      const invitationId = this.invitationId;
      const { id, value } = this.notesList[item];
      const isTrue = Moment(value, "YYYY-MM-DD", true).isValid();

      if (value && isTrue) {
        this.isLoading = true;
        let _this = this;
        getChectoutRemarkByDate(invitationId, id, value).then(res => {
          if (checkNested(res, "data", "content", "model")) {
            if (res.data.content.status === 1) {
              setTimeout(() => {
                this.closeList();
                _this.$router.push({
                  path: `/chectoutremark/${invitationId}/${id}/${value}`
                });
                _this.isLoading = false;
              }, 1000);
            } else {
              _this.isLoading = false;
              this.modalMessage = res.data.content.message;
              this.isShowMessage = true;
            }
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 20px;
  font-weight: bold;
  color: #4a4a4a;
  margin-bottom: 20px;
}
.process {
  h3 {
    font-size: 16px;
    color: #4a4a4a;
    margin-bottom: 16px;
  }
  label {
    min-width: 80px;
    text-align: right;
    font-size: 14px;
    color: #4a4a4a;
    margin-bottom: 0;
  }
  .item {
    margin-bottom: 20px;
    height: 26px;
    line-height: 26px;
  }
  .door-con {
    padding-top: 20px;
    border-top: #ccc 1px dashed;
    border-bottom: #ccc 1px dashed;
    margin-bottom: 26px;
    button {
      color: #fff;
      background-image: linear-gradient(73deg, #f36443, #e42029);
      font-size: 14px;
      height: 26px;
      line-height: 26px;
      border-radius: 4px;
      border: 0;
      margin-left: 20px;
    }
  }
  .notes-con {
    padding-top: 26px;
    button {
      color: #fff;
      background-image: linear-gradient(73deg, #f36443, #e42029);
      font-size: 14px;
      height: 26px;
      line-height: 26px;
      border-radius: 4px;
      border: 0;
    }
  }
  .select-time-con {
    position: relative;
    display: inline-block;
    vertical-align: top;
    margin: 0 20px;
    .ul-con {
      position: absolute;
      top: 26px;
      width: 100%;
      border: 1px solid #ccc;
      border-top: 0;
      background: #fff;
      z-index: 2;
      max-height: 150px;
      overflow-y: scroll;
    }
    li {
      list-style: none;
      font-size: 14px;
      line-height: 26px;
      color: #4a4a4a;
      border-bottom: 1px solid #ccc;
      padding: 0 4px;
      cursor: pointer;
      &:last-child {
        border-bottom: 0;
      }
      &.grey {
        background: #eee;
        color: #888;
      }
      &:hover,
      &.selectActive {
        background: #e42029;
        color: #fff;
      }
    }
  }
  .select-time {
    display: inline-block;
    vertical-align: top;
    border: #ccc 1px solid;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    color: #4a4a4a;
    input {
      height: 24px;
      border: 0;
      margin: 0;
      vertical-align: top;
      padding: 0 4px;
      width: 98px;
      color: #4a4a4a;
    }
    i {
      position: absolute;
      top: 0;
      right: 3px;
      display: inline-block;
      height: 26px;
      line-height: 26px;
      vertical-align: top;
      border-left: #ccc 1px solid;
      &:before {
        font-size: 8px;
        margin-left: 4px;
        position: relative;
        top: -2px;
      }
    }
    &:first-child {
      width: 120px;
      border-right: #ccc 1px solid;
    }
  }
}
.ware-house {
  background-color: #fff;
  border-radius: 10px 10px 0 0;
  width: 100%;
  bottom: 0;
  position: absolute;
  overflow: hidden;
  &.show-warehouse {
    border-radius: 0;
    bottom: inherit;
    height: 100vh;
  }
  & > div:first-child {
    padding: 20px 5% 5px;
    font-size: 18px;
    color: #4a4a4a;
    line-height: 1;
    font-weight: bold;
    em {
      float: right;
      font-size: 22px;
      font-weight: normal;
    }
  }
  .new-invisit-content {
    width: 100%;
    height: calc(100vh - 180px);
    overflow-x: hidden;
    overflow-y: auto;
    .ware-view {
      padding: 20px 5%;
    }
  }
}
</style>